<template>
  <div class="footer">
    <div class="footer__paging">
      <div class="hp-link">
        <u>
          <a href="https://www.hp.com/us-en/privacy/privacy-central.html">
            HP Privacy
          </a>
        </u>
        <u style="padding-left: 10px">
          |<span style="padding-left: 10px" />
          <a href="https://www.hp.com/us-en/privacy/use-of-cookies.html">
            Use of cookies
          </a>
        </u>
      </div>

      <paging-component
        v-show="showPaging"
        :pageSize="loadCount"
        :total="totalItems"
        v-on:currentChange="pagingChangeHandler"
      />
    </div>
    <div class="foot_note">
      <footer>
        <sup>1</sup>Not all MFPs may be compatible with Workpath apps. Not all
        apps may be available in all locations.
      </footer>
    </div>
  </div>
</template>

<script>
import PagingComponent from "./PagingComponent.vue";
import { PAGING_CHANGE_HANDLER } from "../js/event.js";

export default {
  name: "table-footer-controls",
  components: { PagingComponent },
  props: {
    loadCount: { type: Number, default: 10 },
    totalItems: Number,
  },
  computed: {
    showPaging() {
      return this.loadCount < this.totalItems;
    },
  },
  methods: {
    pagingChangeHandler(page) {
      this.$emit(PAGING_CHANGE_HANDLER, page);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/hpMixin.scss";
.footer {
  min-height: 40px;
  margin: 20px 0;

  &__paging {
    @include hpFlex(row);
    min-height: 60px;
  }
}
.hp-link {
  font-family: "FormaDJR";
  font-size: 15.68px;
  position: absolute;
  left: 50px;
  bottom: 55px;
}
.foot_note {
  text-align: left;
  font-size: 14.5 px;
  min-height: 30px;
  margin-left: 15px;
  font-family: "FormaDJR";
}
</style>
